<template>    
    <v-card>
        <!-- Titulo del dialogo -->
        <v-card-title>
            Editar Influencer
            <v-spacer></v-spacer>
            <v-select class="mr-6 ml-12" :disabled="editedItem.department==''" v-show="permissions('assignInfluencers')" v-model="editedItem.parent_id" :items="talentsAgentList" item-value="id" item-text="name" label="Talent Agent"></v-select>
            <v-select class="mr-6" v-model="editedItem.department" :items="bookingList" label="Departamento"></v-select>
        </v-card-title>
        <v-divider></v-divider>
            <!-- Formulario -->
        <v-form ref="form">
            <v-stepper v-model="e1" class="elevation-0">
                <v-stepper-header class="elevation-0">
                    <v-stepper-step style="font-weight:bolder!important;" :complete="e1 > 1" step="1"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step style="font-weight:bolder!important;" step="2"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step style="font-weight:bolder!important;" step="3"></v-stepper-step>
                    <v-divider></v-divider>
                    <v-stepper-step style="font-weight:bolder!important;" step="4"></v-stepper-step>
                </v-stepper-header>
                <v-stepper-items>
                    <v-stepper-content step="1" class="pt-0">
                        <v-row class="py-3 px-6"> 
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field :rules="[v => !!v || 'Campo requerido']" v-model="editedItem.name" label="Nombre"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field v-model="editedItem.last" label="Apellido"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field v-model="editedItem.email" label="Email"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field v-model="editedItem.phone" label="Teléfono"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-select v-model="editedItem.state" :items="statesList" item-value="id" item-text="name" label="Estado"></v-select>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-select :disabled="editedItem.state==undefined || editedItem.state=='' || editedItem.state==null" v-model="editedItem.city" :items="citiesList" item-value="id" item-text="name" label="Ciudad"></v-select>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-menu>
                                    <template v-slot:activator="{ on }">
                                        <v-text-field v-model="editedItem.birth_date" label="Cumpleaños" prepend-icon="mdi-calendar" readonly v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker color="primary" v-model="editedItem.birth_date" @input="datePicker = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field v-model="editedItem.address" label="Dirección"></v-text-field>
                            </v-col>

                            <!--v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="@" v-model="editedItem.social_networks.facebook" label="Facebook"></v-text-field>
                            </v-col-->
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="@" v-model="editedItem.social_networks.instagram" label="Instagram"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="@" v-model="editedItem.social_networks.tiktok" label="TikTok"></v-text-field>
                            </v-col>
                            <!--v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field prefix="@" v-model="editedItem.social_networks.twitter" label="Twitter"></v-text-field>
                            </v-col-->

                            

                        </v-row>
                    </v-stepper-content>
                    <v-stepper-content step="2" class="pt-0">
                        <v-row class="py-3 px-6"> 
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.bank_account_details.bank" label="Banco"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.bank_account_details.account" label="Numero de Cuenta"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.bank_account_details.clabe" label="Clabe Interbancaria"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.bank_account_details.tarejta" label="Tarjeta"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field v-model="editedItem.commission_percentage" suffix="%" label="Porcentaje Comisión" v-if="!editedItem.is_booking"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="4" :md="editedItem.is_booking?'12':'6'" class="py-0">
                                <v-autocomplete class="mb-0 pb-0" v-model="editedItem.tax_regime_id" :items="regimes" item-value="id" item-text="regime" label="Régimen Fiscal"></v-autocomplete>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-text-field class="mb-0 pb-0" v-model="editedItem.rfc" label="RFC o CUPR"></v-text-field>
                            </v-col>
                            
                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.cdf"
                                    label="CDF"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'cdf')"
                                    @click:clear="clearFile('cdf')"
                                />
                                <template v-if="editedItem.cdf && !fileInputs.cdf">
                                    <div class="ml-8 mt-n4" style="font-size: 12px;">
                                        <v-icon small color="primary" class="mr-1">mdi-file</v-icon>
                                        <span>{{ editedItem.cdf }}</span>
                                        <v-btn icon small @click="clearFile('cdf')"><v-icon small>mdi-close</v-icon></v-btn>
                                    </div>
                                </template>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.ine"
                                    label="INE"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'ine')"
                                    @click:clear="clearFile('ine')"
                                />
                                <template v-if="editedItem.ine && !fileInputs.ine">
                                    <div class="ml-8 mt-n4" style="font-size: 12px;">
                                        <v-icon small color="primary" class="mr-1">mdi-file</v-icon>
                                        <span>{{ editedItem.ine }}</span>
                                        <v-btn icon small @click="clearFile('ine')"><v-icon small>mdi-close</v-icon></v-btn>
                                    </div>
                                </template>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.pasaporte"
                                    label="Pasaporte"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'pasaporte')"
                                    @click:clear="clearFile('pasaporte')"
                                />
                                <template v-if="editedItem.pasaporte && !fileInputs.pasaporte">
                                    <div class="ml-8 mt-n4" style="font-size: 12px;">
                                        <v-icon small color="primary" class="mr-1">mdi-file</v-icon>
                                        <span>{{ editedItem.pasaporte }}</span>
                                        <v-btn icon small @click="clearFile('pasaporte')"><v-icon small>mdi-close</v-icon></v-btn>
                                    </div>
                                </template>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.visa"
                                    label="Visa"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'visa')"
                                    @click:clear="clearFile('visa')"
                                />
                                <template v-if="editedItem.visa && !fileInputs.visa">
                                    <div class="ml-8 mt-n4" style="font-size: 12px;">
                                        <v-icon small color="primary" class="mr-1">mdi-file</v-icon>
                                        <span>{{ editedItem.visa }}</span>
                                        <v-btn icon small @click="clearFile('visa')"><v-icon small>mdi-close</v-icon></v-btn>
                                    </div>
                                </template>
                            </v-col>

                            <v-col cols="12" sm="4" md="6" class="py-0">
                                <v-file-input
                                    v-model="fileInputs.comprobante_domicilio"
                                    label="Comprobante de Domicilio"
                                    accept=".pdf,.jpg,.png"
                                    prepend-icon="mdi-paperclip"
                                    @change="uploadFile($event, 'comprobante_domicilio')"
                                    @click:clear="clearFile('comprobante_domicilio')"
                                />
                                <template v-if="editedItem.comprobante_domicilio && !fileInputs.comprobante_domicilio">
                                    <div class="ml-8 mt-n4" style="font-size: 12px;">
                                        <v-icon small color="primary" class="mr-1">mdi-file</v-icon>
                                        <span>{{ editedItem.comprobante_domicilio }}</span>
                                        <v-btn icon small @click="clearFile('comprobante_domicilio')"><v-icon small>mdi-close</v-icon></v-btn>
                                    </div>
                                </template>
                            </v-col>
                        </v-row>
                    </v-stepper-content>

                    <v-stepper-content step="3" class="pt-0">
                        <div v-if="show_tallas">
                            <v-card-title class="mb-0 pb-0">Tallas</v-card-title>
                            <v-row class="ma-0 mt-2 px-2" v-for="(talla, index) in editedItem.tallas" :key="index">
                                <v-col cols="5" class="py-0">
                                    <v-text-field label="Etiqueta" v-model="talla.label"></v-text-field>
                                </v-col>
                                <v-col cols="5" class="py-0">
                                    <v-text-field label="Valor" v-model="talla.value"></v-text-field>
                                </v-col>
                                <v-col cols="2" class="pt-3">
                                    <v-row class="ma-0">
                                        <v-btn @click="removeTalla(index)" icon v-if="editedItem.tallas.length>1"><v-icon>mdi-delete</v-icon></v-btn>
                                        <v-spacer v-if="index>0"/>
                                        <v-btn @click="addTalla(index)" icon><v-icon>mdi-plus</v-icon></v-btn>
                                    </v-row>
                                </v-col>
                            </v-row>
                        </div>
                    </v-stepper-content>

                    <v-stepper-content step="4" class="pt-0">
                        <v-row class="ma-0"> 
                            <v-row class="ma-0 pt-2" style="width:100%;">
                                <div class="pr-2">
                                    <div class="social-switch">
                                        <div @click="social_switch='instagram'" :class="social_switch === 'instagram' ? 'active-social-switch' : 'inactive-social-switch'">
                                            <v-icon color="black" x-small>mdi-instagram</v-icon>
                                            Instagram
                                        </div>
                                        <div @click="social_switch='tiktok'" :class="social_switch === 'tiktok' ? 'active-social-switch' : 'inactive-social-switch'">
                                            <v-icon color="black" x-small>mdi-instagram</v-icon>
                                            TikTok
                                        </div>
                                    </div>
                                </div>
                                <v-spacer/>
                                <v-text-field dense v-model="editedItem[social_switch + '_followers']" label="Followers"></v-text-field>
                            </v-row>

                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].avg_likes" label="Avg. likes"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].avg_comments" label="Avg. Comments"></v-text-field>
                            </v-col>

                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].female_public" suffix="%" prepend-inner-icon="mdi-gender-female" label="Seguidoras"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].male_public" suffix="%" prepend-inner-icon="mdi-gender-male" label="Seguidores"></v-text-field>
                            </v-col>
                            
                            <v-row class="ma-0 pt-6 mt-3" style="border-top:1px solid grey;">

                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-card-subtitle class="ma-0 pa-0 pt-1"><strong>Edad Publico</strong></v-card-subtitle>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0" v-if="social_switch === 'instagram'">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].audience_age[0]" label="13-17 años"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].audience_age[1]" label="18-24 años"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].audience_age[2]" label="25-34 años"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].audience_age[3]" label="35-44 años"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].audience_age[4]" label="45-54 años"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].audience_age[5]" :label="(social_switch === 'instagram'?'55-64' : '55+') + ' años'"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="6" class="py-0" v-if="social_switch === 'instagram'">
                                <v-text-field dense v-model="editedItem.social_networks.metrics[social_switch].audience_age[6]" label="65+ años"></v-text-field>
                            </v-col>

                            </v-row>

                        </v-row>
                    </v-stepper-content>

                    <!--v-stepper-content step="2" class="pt-0">
                    <Servicios
                        <v-row style="background-color: #94949417;" class="px-2 ma-0 py-2 mt-2" v-for="(service,k) in editedItem.services" :key="k">
                            <v-col ols="12" sm ="8" md="6" class="py-0 my-0">
                                <v-text-field v-model="service.service" label="Servicio"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm ="8" md="4" class="py-0 my-0">
                                <v-text-field v-model="service.price" prefix="$" suffix="c/u" label="Precio"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm ="4" md="2">
                                <v-icon @click="remove(k)" v-show="k || ( !k && editedItem.services.length > 1)" color="red">mdi-close</v-icon>
                                <v-icon @click="add(k)" v-show="k == editedItem.services.length-1" color="primary">mdi-plus</v-icon>
                            </v-col>
                        </v-row>
                    </v-stepper-content-->
                </v-stepper-items>
            </v-stepper>
        </v-form>
        

        <v-card-actions class="pt-4">
            <v-autocomplete class="mb-0 pb-0" v-model="editedItem.category_ids" small-chips :items="categories" item-value="id" item-text="name" label="Categoría(s)" multiple chips></v-autocomplete>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="close">
                Cancelar
            </v-btn>
            <v-btn color="blue darken-1" text  v-if="e1>1" @click="e1 = e1-1">
                <v-icon v-if="!isMobile()">mdi-chevron-left</v-icon>
                Regresar
            </v-btn>
            <v-btn color="blue darken-1" text  v-if="e1!=4" @click="e1 = e1+1">
                Siguiente
                <v-icon v-if="!isMobile()">mdi-chevron-right</v-icon>
            </v-btn>
            <v-btn color="blue darken-1" text :disabled="valid" @click="save">
                Guardar
            </v-btn>
        </v-card-actions>
        <v-snackbar :color="snackbar.color" v-model="snackbar.show" style="text-align:center;">
            <strong>{{ snackbar.message }}</strong>
        </v-snackbar>

    </v-card>
</template>
<script>
import axios from "axios";
export default {
    props:{
        editedItem:Object
    },
    data:()=>({ 
        social_switch:'instagram',
        show_tallas:true,
        fileInputs: {
            cdf: null,
            ine: null,
            pasaporte: null,
            visa: null,
            comprobante_domicilio: null
        },
        datePicker:false,
        bookingList:[{text:'Booking', value:'Booking'},{text:'PEACH', value:'PEACH'},{text:'PLUM', value:'PLUM'}],//[{text:'Booking', value:1},{text:'Mgmt', value:0}], 
        disable:'',
        citiesList:[],
        snackbar: {
            show: false,
            message: null,
            color: null
        },
        loadCities:false,
        e1: 1,
    }),
    watch:{
        states:{
            handler(){
                this.getDataFromApi()
            },deep: true,
        }
    },
    created(){
        this.getDataFromApi()
    },
    computed:{
        regimes(){
            return this.$store.state.influencer_regimen.regimenes;
        },
        states(){
            return this.editedItem.state
        },
        categories(){
            return this.$store.state.category.categories
        },
        valid(){
            if(this.editedItem.parent_id!=''&&this.editedItem.name!=''){
                return false
            }else{
                return true
            }
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
        statesList:{
            get(){
                return this.$store.state.state.states
            }
        },
        talentsAgentList(){
            if(this.editedItem.is_booking){
                return this.$store.state.user.users.filter(user=>user.role == 'Booking' || user.role == 'Booking Manager')
            }else{
                return this.$store.state.user.users.filter(user=>user.role == 'Talent Agent' || user.role == 'Talent Agent Manager')
            }
        },
        getDataFromApi(){
            this.loadCities = true
            axios.get(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/cities?state_id=" + this.editedItem.state).then(response => {
                this.loadCities = false
                this.citiesList = response.data
            })
        },
    },
    methods:{
        removeTalla(index){
            this.show_tallas = false
            this.editedItem.tallas.splice(index, 1)
            this.show_tallas = true
        },
        addTalla(){
            this.show_tallas = false
            this.editedItem.tallas.push({label:'', value:''})
            this.show_tallas = true
        },
        async uploadFile(file, fieldName) {
            if (!file) return;

            const formData = new FormData();
            formData.append('file', file);
            formData.append('field', fieldName);
            formData.append('influencer_id', this.editedItem.id);

            try {
                const response = await axios.post(
                process.env.VUE_APP_BACKEND_ROUTE + 'api/v1/sale/file',
                formData,
                { headers: { 'Content-Type': 'multipart/form-data' } }
                );

                this.editedItem[fieldName] = response.data.file; // ← Guarda solo el nombre
            } catch (error) {
                this.snackbar = {
                message: `Error al subir ${fieldName.toUpperCase()}`,
                color: 'error',
                show: true
                };
            }
        },
        clearFile(fieldName) {
            this.fileInputs[fieldName] = null;
            this.editedItem[fieldName] = null;
        },
        permissions(permission){
            if(this.currentUser.id==1){
                return true
            }else if(this.currentUser.permissions!=undefined){
                if(this.currentUser.permissions.includes(permission)){
                    return true
                }else{
                    return false
                }
            }else {
                return false
            }
        },
        isMobile() {
            if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                return true
            } else {
                return false
            }
        },
        close () {
            this.gris = false
            this.$nextTick(() => {
                this.$emit("closeDialogItem", false);
            })
        },
        save () {
            if(this.editedItem.department == 'Booking'){
                this.editedItem.is_booking = true
            }else{
                this.editedItem.is_booking = false
            }
            this.gris = true
            this.$nextTick(() => {
                axios.patch(process.env.VUE_APP_BACKEND_ROUTE + "api/v1/influencers/" + this.editedItem.id,Object.assign(this.editedItem)).then(response=>{
                    this.snackbar = {
                        message: 'Influencer editado(a) con éxito!',
                        color: 'successful',
                        show: true
                    }
                    this.close()
                }).catch(error => {
                    this.snackbar = {
                        message: error.response.data.errors.email[0],
                        color: 'error',
                        show: true
                    }
                })
            })
        },
    }
}
</script>